import styled from 'styled-components'

export const StyledWarningText = styled.p`
    font-family: "Arial", sans-serif;
    font-size: 10px;
    color: grey;
`;
